import { ThemeProvider } from "@/providers/theme-provider.tsx";
import type { AuthState } from "@/types/auth.ts";
import type { QueryClient } from "@tanstack/react-query";
import {
	createRootRouteWithContext,
	HeadContent,
	Outlet,
	Scripts,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfirmationProvider } from "@/providers/confirmation-provider";
import { Toaster } from "../components/ui/sonner.tsx";
import { pageTitle } from "@/utils/page-title.ts";

interface MyRouterContext {
	auth: AuthState;
	queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	// The fallback for any page that names nothing itself; a page's own title
	// replaces it.
	head: () => ({ meta: [{ title: pageTitle() }] }),
	component: RootComponent,
});

function RootComponent() {
	return (
		<>
			<HeadContent />
			<Scripts />
			<ThemeProvider defaultTheme="system">
				<ConfirmationProvider>
					<Outlet />
				</ConfirmationProvider>
				<Toaster richColors={true} />
			</ThemeProvider>
			<TanStackRouterDevtools position="bottom-left" />
			<ReactQueryDevtools buttonPosition="bottom-right" position="bottom" />
		</>
	);
}
